import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { useStore, useStoreActions } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { timeModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import styles from './ActivityLogItem.module.scss';
import { getContent, getIcon } from './ActivityLogItem.utils';
import { NotificationActivityLogEntry } from './NotificationActivityLogEntry';
export default function ActivityLogItem(props) {
    var _useStore;
    const { entry, vendorName, clientName, relationship, isFirst, isLast, variant = 'default' } = props;
    const { logBI } = useStoreActions();
    const isVendor = useStore(selectors.user.isVendor);
    const vendorLogoUrl = (_useStore = useStore(selectors.user.businessLogo)) !== null && _useStore !== void 0 ? _useStore : undefined;
    const featureFlags = useFeatureFlags();
    const testId = "activity-log-".concat(entry.id());
    const { t } = useLocaleKeys();
    const [expandedNotificationId, setExpandedNotificationId] = useState(null);
    const onToggleNotificationExpand = useCallback((id)=>setExpandedNotificationId(id), [
        setExpandedNotificationId
    ]);
    const content = useMemo(()=>{
        if (entry.isSentNotificationEntry()) return null;
        return getContent({
            entry,
            vendorName,
            clientName,
            isVendor,
            relationship,
            testId,
            logBI,
            featureFlags,
            t
        });
    }, [
        entry,
        vendorName,
        clientName,
        relationship,
        testId,
        isVendor,
        featureFlags
    ]);
    useEffect(()=>{
        if (entry.isSentNotificationEntry()) return;
        if (!content) {
            // eslint-disable-next-line no-console
            console.warn('Unrecognized activity-log entry', entry);
        }
    }, [
        content,
        entry
    ]);
    const cardBody = entry.isSentNotificationEntry() ? /*#__PURE__*/ _jsx(NotificationActivityLogEntry, {
        entry: entry,
        isExpanded: expandedNotificationId === entry.id(),
        onToggleExpand: onToggleNotificationExpand,
        vendorLogoUrl: vendorLogoUrl,
        testId: testId
    }) : content ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.icon,
                children: getIcon(entry)
            }),
            /*#__PURE__*/ _jsx(Typography, {
                className: styles.content,
                testId: testId,
                children: content
            })
        ]
    }) : null;
    if (cardBody == null) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.wrapper,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.date,
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: timeModel.formatDateWithTime(entry.timestamp())
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.separator,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.line, {
                            [styles.transparent]: isFirst
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.dot
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.line, {
                            [styles.transparent]: isLast
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.card, variant === 'transparent' && styles.transparent),
                children: cardBody
            })
        ]
    });
}
